function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { CoreVideoInternal } from '../../../core-video-internal';
import { DvrWindowDuration, StreamVendor } from '../../../core/player/playout-data';
import { sdkLogger } from '../../../logger';
import { getLinearStreamInfo } from '../../../utils/stream-vendor';
import { ExtendedWindowManager } from '../extended-window-manager';
import { LinearStreamEndpointFactory } from '../peacock-linear-cdn-builder';
export var OvpUrlExtendedWindowManager = /*#__PURE__*/ function() {
    "use strict";
    function OvpUrlExtendedWindowManager() {
        _class_call_check(this, OvpUrlExtendedWindowManager);
    }
    _create_class(OvpUrlExtendedWindowManager, null, [
        {
            key: "getBestWindowDurationBasedOnPlayerCapabilitiesAndStreamProvider",
            value: function getBestWindowDurationBasedOnPlayerCapabilitiesAndStreamProvider(playbackType) {
                var preferredWindowDuration = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : DvrWindowDuration.Restricted, stream = arguments.length > 2 ? arguments[2] : void 0;
                var extendedWindowConfig = ExtendedWindowManager.getExtendedWindowConfig(playbackType, preferredWindowDuration, CoreVideoInternal.playerCapabilities, CoreVideoInternal.config);
                return extendedWindowConfig[stream.vendor];
            }
        },
        {
            key: "buildExtendedAndFullEventDvrWindowWhenPossible",
            value: function buildExtendedAndFullEventDvrWindowWhenPossible(ovpEndpoints, playbackType) {
                var _this = this;
                var preferredWindowDuration = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : DvrWindowDuration.Restricted;
                var modifiedCdnList = [];
                var unmodifiedCdnList = [];
                // If user requests extended window on linear stream
                // Start with extended window and fall back to unmodified CDNs
                ovpEndpoints.forEach(function(endpoint) {
                    var stream = getLinearStreamInfo(endpoint.url);
                    var windowDuration = _this.getBestWindowDurationBasedOnPlayerCapabilitiesAndStreamProvider(playbackType, preferredWindowDuration, stream);
                    if (stream.vendor !== StreamVendor.Unknown && windowDuration !== DvrWindowDuration.Restricted) {
                        var endpointBuilder = LinearStreamEndpointFactory.fromVendor(stream);
                        var extendedUrl = endpoint.url;
                        if (windowDuration === DvrWindowDuration.Extended) {
                            extendedUrl = endpointBuilder.buildExtendedDvrWindowUrl(endpoint.url, CoreVideoInternal.capabilities);
                            sdkLogger.info("Adding Extended window for vendor: ".concat(stream.vendor));
                        } else if (windowDuration === DvrWindowDuration.FullEvent) {
                            extendedUrl = endpointBuilder.buildFullEventDvrWindowUrl(endpoint.url);
                            sdkLogger.info("Adding FullEvent window for vendor: ".concat(stream.vendor));
                        }
                        modifiedCdnList.push(_object_spread_props(_object_spread({}, endpoint), {
                            url: extendedUrl,
                            name: endpoint.name
                        }));
                    }
                    unmodifiedCdnList.push(_object_spread_props(_object_spread({}, endpoint), {
                        url: endpoint.url,
                        name: endpoint.name
                    }));
                });
                return modifiedCdnList.concat(unmodifiedCdnList);
            }
        }
    ]);
    return OvpUrlExtendedWindowManager;
}();

//# sourceMappingURL=ovp-url-extended-window-manager.js.map